<template>
  <div class="auth-wrapper">
    <b-row class="auth-inner">
      <b-col sm="12">
        <form class="auth-login-form" @submit.prevent="login">
          <img class="auth-login-form-logo" src="@/assets/images/logo.svg" alt="" />
          <b-form-group>
            <label for="login-email"> {{ $t("user.email") }} <span class="required">*</span> </label>
            <b-form-input id="login-email" v-model="userEmail" name="login-email" />
            <div class="input-errors" v-for="error of v$.userEmail.$errors" :key="error.$uid">
              <small class="text-danger">{{ error.$message }}</small>
            </div>
          </b-form-group>

          <b-form-group>
            <label for="login-password"> {{ $t("user.password") }} <span class="required">*</span> </label>
            <b-form-input
              id="login-password"
              v-model="password"
              type="password"
              class="form-control-merge"
              name="login-password"
            />
            <div class="input-errors" v-for="error of v$.password.$errors" :key="error.$uid">
              <small class="text-danger">{{ error.$message }}</small>
            </div>
          </b-form-group>

          <div v-if="invalidCredentials" class="input-errors">
            <small class="text-danger">
              {{ $t("forms.invalidCredentails") }}
            </small>
          </div>

          <div class="login-actions">
            <b-button type="submit" variant="primary" block>
              {{ $t("forms.login") }}
            </b-button>
            <router-link class="forgot-password" to="/forgot-password">{{ $t("forms.forgotPassword") }}</router-link>
          </div>
        </form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import Toast from "@/components/Toast.vue";
import { useToast } from "vue-toastification";
import ListUtils from "@/mixins/ListUtils";

export default {
  components: {},
  mixins: [ListUtils],
  data() {
    return {
      apiUrl: this.$store.state.apiUrl,
      password: "",
      userEmail: "",
      invalidCredentials: false,
    };
  },
  computed: {
    isMultilang() {
      return this.$configHelper.isShopMultilang();
    },
    defaultLanguage() {
      return this.$configHelper.getDefaultLanguage();
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      userEmail: { required: this.$translateError("required") },
      password: { required: this.$translateError("required") },
    };
  },
  methods: {
    async login() {
      this.invalidCredentials = false;
      const isValid = await this.v$.$validate();
      if (isValid) {
        const message = this.$t("messages.welcome");
        this.$JWT
          .login({
            email: this.userEmail,
            password: this.password,
          })
          .then((response) => {
            if (response.code !== 401) {
              this.$JWT.setToken(response.data.token);
              this.$JWT.setRefreshToken(response.data.token);
              this.$Users.getResourceByUrl({ url: response.data.user }, "login").then((userResponse) => {
                const userData = userResponse.data;
                if (["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_EMPLOYEE"].includes(userData.role)) {
                  localStorage.setItem("userData", JSON.stringify(userData));
                  if (this.isMultilang) {
                    localStorage.setItem("sellio_locale", this.defaultLanguage);
                  }
                  const pds = [];
                  this.getPriceDefinitionsList(pds).then(() => {
                    this.$store.dispatch("setPriceDefinitions", pds);
                  });
                  this.$router.replace(getHomeRouteForLoggedInUser(userData, this.$router)).then(() => {
                    const toast = useToast();
                    this.$helper.showToast(toast, Toast, message, "", "success");
                  });
                } else {
                  const toast = useToast();
                  this.$helper.showToast(toast, Toast, this.$t("messages.notAuthorizedLogin"), "", "danger");
                }
              });
            }
          })
          .catch((err) => {
            if (err.response?.data?.message === "Invalid credentials.") {
              this.invalidCredentials = true;
            }
          });
      }
    },
  },
};
</script>
